// store/modules/config.js
import { getWebViewConfig } from '@/api/config'
import { getHm2SiteInfo, unwrapHm2 } from '@/api/hm2'
import { getWebConfig, isWebConfigChanged, setWebConfig } from '@/utils/config'

const state = {
    webViewConfig: null,
    siteInfo: null,
}

const mutations = {
    SET_WEB_VIEW_CONFIG(state, config) {
        state.webViewConfig = config
    },
    SET_SITE_INFO(state, info) {
        state.siteInfo = info
    },
}

const actions = {
    async getWebViewConfig({ commit }) {
        try {
            const response = await getWebViewConfig()
            setWebConfig(response.data)
            commit('SET_WEB_VIEW_CONFIG', response.data)
            return response
        } catch (error) {
            console.error('获取网站设置失败:', error)
            throw error
        }
    },

    async fetchSiteInfo({ commit }) {
        try {
            const response = await getHm2SiteInfo()
            const data = unwrapHm2(response) || {}
            commit('SET_SITE_INFO', data)
            return data
        } catch (error) {
            console.error('获取站点信息失败:', error)
            return null
        }
    },

    // 启动时：先用缓存（秒开），再后台拉新比对是否需要更新
    async bootstrapWebViewConfig({ commit, dispatch }) {
        const cached = getWebConfig()
        if (cached) commit('SET_WEB_VIEW_CONFIG', cached)

        // 并行拉站点公共信息
        dispatch('fetchSiteInfo')

        // 后台刷新：有变化才更新缓存与store
        try {
            const response = await dispatch('refreshWebViewConfigIfNeeded')
            return { cachedUsed: !!cached, ...response }
        } catch (e) {
            return { cachedUsed: !!cached, updated: false, error: e }
        }
    },

    async refreshWebViewConfigIfNeeded({ commit }) {
        const oldConfig = getWebConfig()
        const response = await getWebViewConfig({ force: true })
        const newConfig = response.data

        const changed = isWebConfigChanged(oldConfig, newConfig)
        if (changed) {
            setWebConfig(newConfig)
            commit('SET_WEB_VIEW_CONFIG', newConfig)

            try {
                window.dispatchEvent(
                    new CustomEvent('webconfig:updated', {
                        detail: { oldConfig, newConfig }
                    })
                )
            } catch (e) {
                // ignore
            }
        }

        return { updated: changed, response }
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
